var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Logo"},[_c('div',{staticClass:"LogoImg",class:[{}, _vm.variation],style:({
    width: _vm.size + 'px'
  })})])}
var staticRenderFns = []

export { render, staticRenderFns }